document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("bdSunRxModal");
  if (!modal) return;

  const SUN_LENS_PRICE = "59.90";

  const stepColor = document.getElementById("bdSunStepColor");

  // Open trigger — registered early so it works regardless of form state
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-open-sun-rx-modal]")) {
      e.preventDefault();
      openModal();
    }
  });

  const productForm =
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector("product-form form") ||
    document.querySelector('form[action^="/cart/add"]');

  if (!productForm) return;

  let selectedColor   = null;
  let selectedVariant = null;

  const basePrice = modal.dataset.basePrice || "0";
  const summary = window.BdWizSummary && window.BdWizSummary.mount("bdSunRxModal", basePrice, "Fassung");

  function hideAllSteps() {
    [stepColor].forEach(s => s && (s.style.display = "none"));
  }

  function openModal() {
    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
    if (summary) summary.reset();
    if (bdRxStep) bdRxStep.hide();
    showStepColor();
  }

  function closeModal() {
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
  }

  function showStepColor() {
    hideAllSteps();
    if (stepColor) stepColor.style.display = "block";
    selectedColor = null;
    selectedVariant = null;
  }

  // ── Sehstärke übermitteln (shared step) ─────────────────

  const bdRxStep = window.BdRxStep && window.BdRxStep.mount({
    prefix: "bdSunRx",
    onBack: showStepColor,
    onComplete: function (rxProps, fileInput) {
      const properties = Object.assign({
        "Glasfarbe": selectedColor,
        "Gläserpaket Aufpreis (CHF)": SUN_LENS_PRICE,
      }, rxProps);
      closeModal();
      window.BdCartEngine.submit({
        productForm: productForm,
        properties: properties,
        fileInput: fileInput,
        addonVariantId: selectedVariant,
      });
    },
  });

  // Close
  modal.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest("[data-bd-sun-close]")) closeModal();
  });

  // Step 1: Color (tap-to-advance)
  document.querySelectorAll("#bdSunStepColor .bd-usagecard").forEach(btn => {
    btn.addEventListener("click", () => {
      selectedColor   = btn.getAttribute("data-sun-color");
      selectedVariant = parseInt(btn.getAttribute("data-sun-variant"));
      if (summary) summary.set("lens", "Farbe: " + selectedColor, SUN_LENS_PRICE);
      hideAllSteps();
      if (bdRxStep) bdRxStep.show();
    });
  });
});
